<template>
  <v-menu offset-y :close-on-content-click="false" v-model="show_filters">
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        class="mr-4 bold text-capitalize"
        color="primaryGrey"
        small
        outlined
        v-bind="attrs"
        v-on="on"
        >Filters</v-btn
      >
    </template>
    <div class="secondary_filters">
      <div
        class="filter"
        v-for="(item, index) in filters.list_checkbox"
        :key="`sec_${index}`"
      >
        <div>{{ item.label }}</div>
        <v-list dense>
          <v-list-item-group
            :multiple="multiple"
            v-model="filter_conditions[item.value]"
          >
            <template v-for="(value, i) in item.values">
              <v-list-item
                :key="`item-${i}`"
                :value="value"
                active-class="primary--text text--accent-4"
              >
                <template v-slot:default="{ active }">
                  <v-list-item-content>
                    <v-list-item-title v-text="value"></v-list-item-title>
                  </v-list-item-content>

                  <v-list-item-action>
                    <v-checkbox
                      :input-value="active"
                      color="primary"
                    ></v-checkbox>
                  </v-list-item-action>
                </template>
              </v-list-item>
            </template>
          </v-list-item-group>
        </v-list>
      </div>
      <div
        class="filter"
        v-for="(item, index) in filters.range"
        :key="`sec_range_${index}`"
      >
        {{ item.label }}
        <v-slider
          dense
          v-model="filter_conditions_range[`${item.value}_min`]"
          label="min"
          :max="item.max"
          :min="item.min"
          thumb-color="error lighten-1"
          thumb-label="always"
          thumb-size="20"
        ></v-slider>
        <v-slider
          dense
          v-model="filter_conditions_range[`${item.value}_max`]"
          label="max"
          :max="item.max"
          :min="item.min"
          thumb-color="primaryOutline"
          thumb-label="always"
          thumb-size="20"
        ></v-slider>
      </div>
      <div
        class="filter flags"
        v-for="(item, index) in filters.flags"
        :key="`sec_flag_${index}`"
      >
        <v-checkbox
          dense
          v-model="filter_conditions_flags[`${item.value}`]"
          :label="item.label"
        ></v-checkbox>
      </div>
      <div class="py-1 text-right">
        <v-btn x-small outlined dense class="mr-2 bold" @click="clear_filters"
          >Clear</v-btn
        >
        <v-btn
          x-small
          color="primary"
          @click="
            apply_filters({
              checkbox: filter_conditions,
              range: filter_conditions_range,
              flags: filter_conditions_flags,
            })
          "
          class="bold"
          >Apply</v-btn
        >
      </div>
    </div>
  </v-menu>
</template>

<script>
export default {
  name: "SecondaryFiltersVT",
  props: { filters: Object, multiple: Boolean },
  watch: {},
  data: function () {
    return {
      filter_conditions: {},
      show_filters: false,
      filter_conditions_range: {},
      filter_conditions_flags: {},
    };
  },
  methods: {
    apply_filters: function (filter_conditions) {
      this.show_filters = false;
      this.$emit("apply_filters", filter_conditions);
    },
    clear_filters: function () {
      this.show_filters = false;
      this.filter_conditions = {};
      this.filter_conditions_range = {};
      this.filter_conditions_flags = {};
      this.$emit("clear_filters");
    },
  },
  computed: {},
};
</script>
<style lang="scss" scoped>
.secondary_filters {
  background-color: var(--v-backgroundWhite-base);
  padding: 0.5em;
  font-size: 0.7em;
  min-width: 250px;

  .filter {
    border-bottom: 1px solid var(--v-border-base);
    margin-bottom: 0.5em;
    ::v-deep .v-list-item--dense,
    .v-list--dense .v-list-item {
      min-height: 28px;
      .v-list-item__content {
        padding: 0px;
      }
      .v-list-item__action {
        margin-top: 2px;
        margin-bottom: 2px;
      }
    }
  }
  .filter.flags {
    ::v-deep .v-label {
      font-size: 0.9em;
    }
  }
}
</style>
